import { Offering } from '@arrived/models';

export const isRentInfoSectionEnabled = (offering: Offering) => {
  const firstDividend = offering.projectedFirstDividendAmount;
  const firstDividendDate = offering.projectedFirstDividendDate;
  const firstDividendYield = offering.projectedAnnualDividendYield;
  return Boolean(firstDividend || firstDividendDate || firstDividendYield);
};
